<script lang="ts" setup>
import { LineBlockLine } from "@types"
import { useI18n } from "vue-i18n"

import { useResponsive } from "@core/composables"

const { isMobile } = useResponsive()

defineEmits<{
    (e: "click:edit", line: LineBlockLine): void
}>()

withDefaults(
    defineProps<{
        line: LineBlockLine
        loading: boolean
        edit?: boolean
    }>(),
    {
        loading: false,
        edit: false,
    }
)

const { t } = useI18n({
    messages: {
        fr: {
            edit_line: "Modifier",
        },
    },
})
</script>

<template>
    <div
        class="base-line-block group flex flex-col md:flex-row md:items-center gap-2 self-stretch p-2 hover:bg-cyan-50"
    >
        <!-- Titre -->
        <!-- text à gauche (label) -->
        <div
            class="flex flex-row gap-2 items-center justify-start w-full max-w-60"
        >
            <p
                class="group-hover:text-blue-700 whitespace-pre-line text-sm truncate"
            >
                {{ line.text }}
            </p>
            <!-- tooltip optionel -->
            <BaseIcon
                v-if="line.tooltip"
                icon="pi pi-exclamation-circle"
                v-tooltip="line.tooltip"
                size="0.8rem"
            />
        </div>

        <!-- Valeur -->
        <div
            v-if="!loading"
            class="flex md:flex-row flex-col items-start md:items-center gap-2 min-h-7 border-t-2 pt-2 md:border-t-0 md:pt-0 md:pl-2 md:border-l-2 text-sm border-gray-200 group-hover:border-cyan-400 group-hover:text-blue-700"
        >
            <slot v-if="!$slots[line?.id ?? '']"
                ><p>{{ line.value }}</p></slot
            >
            <slot v-if="line.id" :name="line.id" v-bind="line"></slot>
            <BaseButton
                v-if="edit"
                class="w-fit"
                icon="pi pi-pencil"
                variant="link"
                rounded
                size="small"
                :label="isMobile ? t('edit_line') : ''"
                v-tooltip="t('edit_line')"
                @click.stop="$emit('click:edit', line)"
            />
            <slot name="actions"></slot>
        </div>
        <BaseSkeleton
            v-else
            width="100%"
            height="1.5rem"
            class="inline-block"
        />
    </div>
</template>
